module.exports = __webpack_public_path__ + "static/media/pyramid_l.0f2c02e9.svg";